export const KEY_REDUCER_LIBRARY = "library";
export const LOADER_ID_FETCH_ALL_HISTORY = "fetch/allHistory";
